import { formatDateTooltip } from '@/utils/dateTooltip';

function update(el, binding) {
    const tooltip = formatDateTooltip(binding.value === undefined ? el.textContent : binding.value);
    if (tooltip) el.setAttribute('title', tooltip);
    else el.removeAttribute('title');
}

export default { mounted: update, updated: update };
